// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ADS Monetization Styling */
.ads-monetization-container {
  padding: 20px;
}

.commission-summary-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.commission-summary-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.commission-percentage {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 5px;
}

.commission-percentage.advertisement {
  color: #007bff;
}

.commission-percentage.admin {
  color: #28a745;
}

.commission-percentage.total {
  color: #6f42c1;
}

.commission-percentage.total.warning {
  color: #dc3545;
}

.commission-percentage.remaining {
  color: #20c997;
}

.commission-percentage.remaining.negative {
  color: #dc3545;
}

.status-indicator {
  display: flex;
  align-items: center;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.status-indicator.enabled {
  background-color: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.status-indicator.disabled {
  background-color: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.status-icon {
  margin-right: 15px;
  font-size: 1.5rem;
}

.validation-alert {
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  border: none;
  font-weight: 500;
}

.validation-alert.success {
  background-color: #d4edda;
  color: #155724;
  border-left: 4px solid #28a745;
}

.validation-alert.danger {
  background-color: #f8d7da;
  color: #721c24;
  border-left: 4px solid #dc3545;
}

.help-section {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  border-left: 4px solid #17a2b8;
}

.help-section h5 {
  color: #495057;
  margin-bottom: 15px;
}

.help-section ul {
  margin-bottom: 0;
  padding-left: 20px;
}

.help-section li {
  margin-bottom: 8px;
  color: #6c757d;
}

.form-section {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

.form-section h4 {
  color: #343a40;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e9ecef;
}

.percentage-input {
  position: relative;
}

.percentage-input::after {
  content: '%';
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-weight: 500;
  pointer-events: none;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 25px;
}

.summary-item {
  text-align: center;
  padding: 20px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.summary-item:hover {
  border-color: #007bff;
  box-shadow: 0 2px 10px rgba(0, 123, 255, 0.1);
}

.summary-label {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 500;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.summary-value {
  font-size: 1.75rem;
  font-weight: bold;
  margin-bottom: 0;
}

.toggle-section {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  border: 1px solid #e9ecef;
  margin-top: 20px;
}

.toggle-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 10px;
  display: block;
}

.toggle-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.toggle-status {
  font-weight: 500;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.875rem;
}

.toggle-status.enabled {
  background-color: #d4edda;
  color: #155724;
}

.toggle-status.disabled {
  background-color: #f8d7da;
  color: #721c24;
}

/* Responsive Design */
@media (max-width: 768px) {
  .ads-monetization-container {
    padding: 15px;
  }
  
  .commission-summary-card {
    padding: 15px;
  }
  
  .commission-percentage {
    font-size: 1.5rem;
  }
  
  .summary-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .form-section {
    padding: 20px;
  }
}

@media (max-width: 576px) {
  .toggle-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .status-indicator {
    padding: 12px;
  }
  
  .validation-alert {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Ads_Categories/Ads_Monetization/AdsMonetization.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ADS Monetization Styling */\n.ads-monetization-container {\n  padding: 20px;\n}\n\n.commission-summary-card {\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 20px;\n  transition: all 0.3s ease;\n}\n\n.commission-summary-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.commission-percentage {\n  font-size: 2rem;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.commission-percentage.advertisement {\n  color: #007bff;\n}\n\n.commission-percentage.admin {\n  color: #28a745;\n}\n\n.commission-percentage.total {\n  color: #6f42c1;\n}\n\n.commission-percentage.total.warning {\n  color: #dc3545;\n}\n\n.commission-percentage.remaining {\n  color: #20c997;\n}\n\n.commission-percentage.remaining.negative {\n  color: #dc3545;\n}\n\n.status-indicator {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  transition: all 0.3s ease;\n}\n\n.status-indicator.enabled {\n  background-color: #d4edda;\n  border-color: #c3e6cb;\n  color: #155724;\n}\n\n.status-indicator.disabled {\n  background-color: #fff3cd;\n  border-color: #ffeaa7;\n  color: #856404;\n}\n\n.status-icon {\n  margin-right: 15px;\n  font-size: 1.5rem;\n}\n\n.validation-alert {\n  border-radius: 8px;\n  padding: 15px;\n  margin-bottom: 20px;\n  border: none;\n  font-weight: 500;\n}\n\n.validation-alert.success {\n  background-color: #d4edda;\n  color: #155724;\n  border-left: 4px solid #28a745;\n}\n\n.validation-alert.danger {\n  background-color: #f8d7da;\n  color: #721c24;\n  border-left: 4px solid #dc3545;\n}\n\n.help-section {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n  border-left: 4px solid #17a2b8;\n}\n\n.help-section h5 {\n  color: #495057;\n  margin-bottom: 15px;\n}\n\n.help-section ul {\n  margin-bottom: 0;\n  padding-left: 20px;\n}\n\n.help-section li {\n  margin-bottom: 8px;\n  color: #6c757d;\n}\n\n.form-section {\n  background-color: #ffffff;\n  border-radius: 8px;\n  padding: 25px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  margin-bottom: 20px;\n}\n\n.form-section h4 {\n  color: #343a40;\n  margin-bottom: 20px;\n  padding-bottom: 10px;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.percentage-input {\n  position: relative;\n}\n\n.percentage-input::after {\n  content: '%';\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6c757d;\n  font-weight: 500;\n  pointer-events: none;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 25px;\n}\n\n.summary-item {\n  text-align: center;\n  padding: 20px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  border: 1px solid #e9ecef;\n  transition: all 0.3s ease;\n}\n\n.summary-item:hover {\n  border-color: #007bff;\n  box-shadow: 0 2px 10px rgba(0, 123, 255, 0.1);\n}\n\n.summary-label {\n  font-size: 0.875rem;\n  color: #6c757d;\n  font-weight: 500;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.summary-value {\n  font-size: 1.75rem;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.toggle-section {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n  border: 1px solid #e9ecef;\n  margin-top: 20px;\n}\n\n.toggle-label {\n  font-weight: 600;\n  color: #495057;\n  margin-bottom: 10px;\n  display: block;\n}\n\n.toggle-container {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.toggle-status {\n  font-weight: 500;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 0.875rem;\n}\n\n.toggle-status.enabled {\n  background-color: #d4edda;\n  color: #155724;\n}\n\n.toggle-status.disabled {\n  background-color: #f8d7da;\n  color: #721c24;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .ads-monetization-container {\n    padding: 15px;\n  }\n  \n  .commission-summary-card {\n    padding: 15px;\n  }\n  \n  .commission-percentage {\n    font-size: 1.5rem;\n  }\n  \n  .summary-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n  \n  .form-section {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 576px) {\n  .toggle-container {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n  \n  .status-indicator {\n    padding: 12px;\n  }\n  \n  .validation-alert {\n    padding: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
